import React, { useState } from 'react';
import Tag from './Tag';
import { clone } from 'lodash';
import DataList from '../datalist/DataList';
import PropTypes from 'prop-types';
import IncrementButton from '../../buttons/incrementButton/IncrementButton';
import style from './TagInput.module.css';

function TagInput({ prevTags, retrieveCurrentTags }) {
  const [tags, setTags] = useState([]);
  const [inputVal, setInputVal] = useState('');

  const removeTag = (i) => {
    if (tags.length > 0){
      const cloneArr = clone(tags);
      cloneArr.splice(i, 1);
      setTags(cloneArr);
      retrieveCurrentTags(cloneArr);
    }
  };

  const addTag = () => {
    if (!tags.includes(inputVal) && inputVal !== ''){
      const newArr = [...tags, inputVal];
      setTags(newArr);
      retrieveCurrentTags(newArr);
    }
  };
  return (
    <div className={style.tagInputContainer}>
      <div className={style.tagArea}>
        {tags.map((tag, i) => (
          <Tag key={tag} closeHandler={removeTag} index={i}>
            {tag}
          </Tag>
        ))}
      </div>
      <div className={style.inputAndButton}>
        <DataList
          dataList={prevTags}
          dataMapFunc={(tag) => {
            return <option value={tag} key={tag}/>;
          }}
          inputHandler={(value) => setInputVal(value)}
          inputVal={inputVal}
          id="tags"
        >
          Tags...
        </DataList>
        <IncrementButton
          backgroundColor="grey"
          color="white"
          width={10}
          paddingPercent={20}
          stroke={2}
          handleClick={addTag}
          margin="0 5px"
        />
      </div>
    </div>
  );
}
TagInput.propTypes = {
  prevTags: PropTypes.array.isRequired,
  retrieveCurrentTags: PropTypes.func.isRequired,
};

export default TagInput;
